import axios from "axios";
import { createI18n } from 'vue-i18n'
class I18n{
    constructor() {
        this.i18n = createI18n({
            legacy: false,
            locale: document.documentElement.lang,
        })
    }
    init(keys, app, callback, base = ''){
        app.use(this.i18n)
        app.config.globalProperties.t = this.i18n.global.t
        axios.post(`${base}translations/getTranslations`, {keys: keys}, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).then(response => {
            this.i18n.global.mergeLocaleMessage(document.documentElement.lang, response.data)
            callback();
        });
    }

    load(keys, translations, callback, base = ''){
        axios.post(`${base}translations/getTranslations`, {keys: keys}, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).then( response => {

            for(let k in response.data){
                translations[k] = response.data[k]
            }
            callback();
        });
    }
}

export default new I18n()

